import React from 'react';
import Announce from '../components/Announce';
import Counter from '../components/Counter';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import Newsletter from '../components/Newsletter';

const ProductPage = ({ onChangePage }) => {
  return (
    <div>
      <Announce />
      <Navbar onChangePage={onChangePage} />
      <div className="flex justify-center mobile:flex-col mobile:mt-3 mobile:p-3">
        <div className="flex flex-1 justify-center items-center">
          <img className="w-4/5 h-4/5 rounded-lg shadow-lg hover:scale-110 ease-in duration-300" src="https://cdn.shopify.com/s/files/1/0240/7285/products/KNITPULLOVER-PISTACHIO-2_360x.jpg?v=1642545216" alt="product_image" />
        </div>
        <div className="flex flex-[1.3] justify-items-start items-start flex-col mt-10 mobile:items-center">
          <h1 className="title text-[40px] mobile:text-3xl">Creamy Hoody Original</h1>
          <p className="pr-[4rem] text-justify mt-4 mobile:pr-0">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae repellendus, optio iure impedit explicabo enim deleniti tempore commodi dolor ratione, earum pariatur. Perferendis ut nemo quibusdam quaerat dolorum rerum ipsam?
          </p>
          <p className="mt-7 text-3xl">
            Price: <b>$70</b>
          </p>
          <div className="flex text-2xl gap-5 mt-7">
            <p>Colors</p>
            <div className="bg-red-600 w-8 h-8 rounded-full border-2 p-[10px] cursor-pointer hover:border-[#8a4af3]"></div>
            <div className="bg-sky-600 w-8 h-8 rounded-full border-2 p-[10px] cursor-pointer hover:border-[#8a4af3]"></div>
            <div className="bg-yellow-400 w-8 h-8 rounded-full border-2 p-[10px] cursor-pointer hover:border-[#8a4af3]"></div>
          </div>
          <div className="flex text-2xl gap-5 mt-7">
            <p>Size</p>
            <select>
              <option selected disabled>
                Select
              </option>
              <option value="Small">Small</option>
              <option value="Medium">Medium</option>
              <option value="Large">Large</option>
            </select>
          </div>
          <div className="mt-5">
            <Counter />
          </div>
          <button className="btn mt-5" onClick={() => onChangePage('CartPage')}>
            Add to cart
          </button>
        </div>
      </div>
      <Newsletter />
      <Footer />
    </div>
  );
};

export default ProductPage;
